import React from 'react';

interface LabelValueRowProps {
  label: string;
  children: React.ReactNode;
  readOnly?: boolean;
  fullWidth?: boolean;
}

export const LabelValueRow: React.FC<LabelValueRowProps> = ({
  label,
  children,
  readOnly,
  fullWidth
}) => (
  <div className={`grid gap-2 py-1 ${fullWidth ? 'grid-cols-1' : 'grid-cols-1 sm:grid-cols-[minmax(0,180px)_1fr]'} items-center`}>
    <dt className="text-sm font-medium vscode-text-secondary shrink-0">
      {label}
      {readOnly && <span className="ml-1.5 text-xs vscode-text-tertiary">(Read-only)</span>}
    </dt>
    <dd className="min-w-0 w-full vscode-text-primary [&_select]:min-w-[10rem] [&_select]:min-h-[2.25rem] [&_select]:block [&_select]:overflow-visible">
      {children}
    </dd>
  </div>
);

export default LabelValueRow;
